module.exports = __webpack_public_path__ + "img/play-icon.3892e7a1.svg";